module.exports = __webpack_public_path__ + "static/img/highwire-logo.3756f2fb.svg";